import { useCallback } from 'react'
import { defaultOffer } from 'constants/DebtAssessment'

const PRODUCT_OFFER_KEY = {
  AR: 'ar_offers',
  PL: 'apl_offers',
  HL: 'ahl_offers',
}

function extractOffer(offersAvailable, productTypeTerms) {
  let idx = 0

  if (productTypeTerms) {
    const found = offersAvailable?.findIndex((i) => i?.terms === productTypeTerms) ?? -1
    if (found >= 0) idx = found
  } else {
    const filtered = offersAvailable?.filter((i) => i.terms_category == defaultOffer)
    if (filtered?.length) offersAvailable = filtered
  }

  const offer = offersAvailable?.[idx]
  return {
    totalCost: offer?.total_cost || 0,
    monthlyPayment: offer?.monthly_payment || 0,
    years: Math.round((offer?.terms || 0) / 12),
  }
}

function extractPayoffPlan(assessment) {
  const plan = assessment?.cfos?.payoff_plans?.[0]
  return {
    totalCost: Math.round(plan?.total_amount || 0),
    monthlyPayment: Math.round(plan?.starting_total_monthly_payment || 0),
    years: Math.round((plan?.time_in_months || 0) / 12),
  }
}

export function useGraphData({ data, productType, productTypeTerms }) {
  return useCallback(() => {
    if (data?.achieveOffer && data?.currentOffer && data?.waitOffer) {
      return {
        achieveOffer: { ...data.achieveOffer },
        currentOffer: { ...data.currentOffer },
        waitOffer: { ...data.waitOffer },
      }
    }

    const offerKey = PRODUCT_OFFER_KEY[productType]
    const offersAvailable = data?.default_offers?.[offerKey]

    return {
      achieveOffer: extractOffer(offersAvailable, productTypeTerms),
      currentOffer: extractPayoffPlan(data?.current_assessment),
      waitOffer: extractPayoffPlan(data?.projected_assessment),
    }
  }, [data, productType, productTypeTerms])
}
